import * as React from "react";
import { MessageBar, MessageBarType } from "office-ui-fabric-react";
import "../css/Common.css";

export interface SavedMattersProps {
  savedMatters: any[];
  isItemChanged: boolean;
}

export interface SavedMattersState {
  savedMatters: any[];
}

class SavedMatters extends React.Component<
  SavedMattersProps,
  SavedMattersState
> {
  constructor(props, {}) {
    super(props, {});
    this.state = {
      savedMatters: []
    };
  }
  render() {
    let matterNames = [];
    this.state.savedMatters.forEach(matter => {
      let date = typeof matter.date !== "undefined" ? matter.date : "";
      let text = `"${matter.text}"` + " " + date;
      matterNames.push(text);
    });

    return (
      <div>
        {matterNames.length > 0 && (
          <MessageBar
            className="msg-bar2"
            messageBarType={MessageBarType.info}
            isMultiline={true}
          >
            <span
              style={{
                fontFamily: "Lato",
                fontWeight: "normal",
                fontSize: 14
              }}
            >{`Previously saved to Matter ${matterNames.join(", ")}`}</span>
          </MessageBar>
        )}
      </div>
    );
  }
  componentWillReceiveProps(_nextProps) {
    if (this.props.savedMatters.length === 0 || this.props.isItemChanged) {
      let savedMatters = [];
      let item = Office.context.mailbox.item;
      item.loadCustomPropertiesAsync(asyncResult => {
        let customProps = asyncResult.value;

        let matters = customProps.get("SavedMatters");
        if (typeof matters !== "undefined") {
          savedMatters = matters;
          this.setState({ savedMatters: savedMatters });
        } else {
          this.setState({ savedMatters: [] });
        }
      });
    } else {
      this.setState({ savedMatters: this.props.savedMatters });
    }
  }
}

export default SavedMatters;
